// extracted by mini-css-extract-plugin
module.exports = {"overAll":"missingskills_overAll__1jZKo","scroll":"missingskills_scroll__2YZ7N","title":"missingskills_title__1e-PA"};